/**
 * Created by Jodie on 2019/5/8.
 */
import HttpService from './appService.js'

var service = {};
/**
 * 获取验证码
 * @param vm
 * @param mobile
 */
service.sendVerifyCode = function(vm,mobile){
  return HttpService.get(vm,'yqy-platform/applyContact/sendVerifyCode',{mobile:mobile});
};
/**
 * 提交客户信息
 * @param vm  verifyCode
 * @param form {} agencyName、mobile、applyContactName
 */
service.save = function(vm,verifyCode,form){
  return HttpService.post(vm,'yqy-platform/applyContact/save',form,{verifyCode:verifyCode})
};
export default service;



// WEBPACK FOOTER //
// ./src/js/allservice.js